import dashboard from "./dashboard.js";
import login from "./login.js";
import register from "./register.js";
import home from "./home.js";
import detail from "./detail.js";
import newVendor from "./newVendor.js";
import vendor from "./vendor.js";
import vendorDetail from "./vendorDetail.js";
import assistant from "./assistant.js";
import DataCenterBookingDetail from "./DataCenterBookingDetail";
import DSBKoverview from "./DSBKoverview.js";
import DataCenter from "./DataCenter.js";
import DCbuy from "./DCbuy.js";
import DCBKrecord from "./DCBKrecord.js";
import edit from "./edit.js";
import list from "./list.js";
import DCissue from "./DCissue.js";
import DCredeem from "./DCredeem.js";
import DCdiscount from "./DCdiscount.js";
import ticket from "./ticket.js";
import approver_dashboard from "./approver_dashboard.js";
import password from "./password.js"
import takeaway from "./takeaway.js"
import Event from "./Event.js"
import Partner from "./Partner.js"
import Invite from "./Invite.js"
import Estamp from "./Estamp.js"
import DCtransfer from "./DCtransfer.js"
import DCearn from "./DCearn.js"
import reward from "./reward.js"
import AdCarousel from "./AdCarousel.js"
import pushNotification from "./pushNotification.js";

export default {
  dashboard,
  login,
  register,
  home,
  detail,
  newVendor,
  vendor,
  vendorDetail,
  assistant,
  DataCenterBookingDetail,
  DSBKoverview,
  DataCenter,
  DCbuy,
  DCBKrecord,
  edit,
  list,
  DCissue,
  DCredeem,
  DCdiscount,
  ticket,
  approver_dashboard,
  password,
  takeaway,
  Event,
  Partner,
  Invite,
  Estamp,
  DCtransfer,
  DCearn,
  reward,
  AdCarousel,
  pushNotification,
};
